// extracted by mini-css-extract-plugin
export default {"modes":"SwapForm_modes__jpaa3"};